export default {
  allLocations: [],
}
